var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.685 8.807-1.678-1.675c-.6-.598-1.618-.359-1.858.419-.18.538-.779.837-1.318.718-1.199-.3-2.817-1.855-3.117-3.11-.18-.539.18-1.137.72-1.316.778-.24 1.018-1.256.419-1.854L3.175.314c-.48-.419-1.199-.419-1.619 0L.418 1.45c-1.14 1.197.12 4.366 2.936 7.177 2.817 2.811 5.994 4.127 7.193 2.931l1.138-1.136c.42-.479.42-1.197 0-1.615Z",
    fill: "#fff"
  })));
};
export default SvgCall;